export function decodeURIComponentSafe(text: string) {
  if (!text) {
    return text;
  }
  return decodeURIComponent(text.replaceAll(/%(?!\d[\dA-Fa-f]+)/g, "%25"));
}
